'use client'

import { Reveal } from '../Reveal'
import { ArrowIcon } from '../Icons'

export function CTA(): React.ReactElement {
  return (
    <section className="relative overflow-hidden py-20 md:py-24">
      {/* gold gradient band */}
      <div className="absolute inset-0 bg-gold-gradient" />
      <div className="absolute inset-0 opacity-20 mix-blend-overlay grid-overlay" />
      <div className="absolute inset-0 bg-charcoal-950/10" />

      <div className="container-x relative text-center">
        <Reveal>
          <h2 className="font-heading text-3xl font-black leading-tight text-charcoal-950 sm:text-4xl md:text-5xl">
            عندك مشروع بناء أو تشطيب؟
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg font-semibold text-charcoal-900">
            خلنا نبدأ من فكرتك ونحوّلها إلى مشروع على أرض الواقع.
          </p>
          <div className="mt-9">
            <a
              href="#quote"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-charcoal-950 px-8 py-4 text-base font-bold text-gold-300 shadow-card transition-all duration-300 hover:-translate-y-0.5 hover:bg-charcoal-900"
            >
              ابدأ مشروعك الآن
              <ArrowIcon className="h-5 w-5" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
